import { useGtag } from '#imports'

/**
 * Thin wrapper around the nuxt-gtag `useGtag` auto-import. Isolating the `#imports` access here lets
 * plugin/pipeline code that needs gtag be unit-tested (this module is mocked in specs) without the
 * Nuxt imports transform trying to resolve `useGtag`, which is not registered in the test build.
 */
export function getGtag(): { gtag: ((...args: unknown[]) => void) | undefined } {
  return useGtag()
}

/** Applies GA4 User-ID at tag scope so it covers every configured destination stream. */
export function setGtagUserId(gtag: ((...args: unknown[]) => void) | undefined, contactId: string | null): void {
  gtag?.('set', { user_id: contactId })
}
